import { jsx as _jsx } from "react/jsx-runtime";
import { ConstituentNotConfiguredWidget } from '@modules/constituents/widget/constituent-not-configured-widget';
import { assignTestId } from '@common/infra/tests/assign-test-id';
export function CwmNotConfiguredWidget(props) {
    return (_jsx(ConstituentNotConfiguredWidget, { ...props, ...assignTestId('widget-code-with-me'), children: "Code With Me is ready to use. Enable the product in a profile and assign the profile to users to grant them access." }));
}
